import { AUTH_SUCCESS, SESSION_TIMEOUT_MODAL, SAVE_DOCUSIGN_INFO } from '../types/auth'
import {
  loginAPI,
  switchAppAPI,
  changeShopAPI,
  getCurrentSessionAPI,
  resetPasswordAPI,
  recoverPasswordAPI,
  renewSessionAPI,
  reviewCompanyAgreementAPI,
} from '../api/auth'
import { addMessageCurry, getSession, commonActionAPIHit } from '../utils/api'
import { getShopListAPI } from '../api/shop'
import momentTZ from 'moment-timezone'
import { saveUpdatedShop } from './shop'
import { stringFormatter } from '../utils/common'
import { clearHubSpot, initHubSpot } from '../utils/crm'

export const authSuccess = (payload) => ({
  type: AUTH_SUCCESS,
  payload: payload,
})

export const setDocuSignInfo = (payload) => ({
  type: SAVE_DOCUSIGN_INFO,
  payload: payload,
})

export const changeShop = (shopId, appType = '') => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      let data = appType ? { shopId, growAppType: appType } : { shopId }
      addMessageCurry(changeShopAPI(data), dispatch).then(async (session) => {
        session = await enrichSessionWithGrowthLoyalty(session)
        resolve(session)
        dispatch(authSuccess({ session }))
      })
    })
  }
}

export const switchApp = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const session = getSession()

      addMessageCurry(
        switchAppAPI({
          ...data,
          accessToken: session.accessToken,
        }),
        dispatch,
      )
        .then((session) => {
          resolve(session)
        })
        .catch((err) => console.log(err))
    })
  }
}

const enrichSessionWithGrowthLoyalty = async (session) => {
  if (!session || !session.assignedShop) return session
  try {
    const shopsResponse = await getShopListAPI()
    const shops = shopsResponse && shopsResponse.values
    if (shops) {
      const matchingShop = shops.find((s) => s.id === session.assignedShop.id)
      if (matchingShop) {
        return {
          ...session,
          assignedShop: {
            ...session.assignedShop,
            enableGrowthLoyalty: matchingShop.enableGrowthLoyalty || false,
          },
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  return session
}

export const getCurrentSession = (headers = {}) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      addMessageCurry(getCurrentSessionAPI(headers), dispatch)
        .then(async (session) => {
          session = await enrichSessionWithGrowthLoyalty(session)
          resolve(session)
          dispatch(authSuccess({ session }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getCurrentSessionNoStore = (headers = {}) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      addMessageCurry(getCurrentSessionAPI(headers), dispatch)
        .then((session) => {
          resolve(session)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const login = (user) => {
  return (dispatch) => {
    const timezone = momentTZ.tz.guess()

    const data = { ...user, timezone }

    return new Promise(async (resolve, reject) => {
      addMessageCurry(loginAPI(data), dispatch)
        .then(async (session) => {
          session = await enrichSessionWithGrowthLoyalty(session)
          resolve(session)
          dispatchAuthSuccess(dispatch, session)
        })
        .catch((err) => reject(err))
    })
  }
}

export const renewSession = (payload) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      addMessageCurry(renewSessionAPI(payload), dispatch)
        .then(async (session) => {
          session = await enrichSessionWithGrowthLoyalty(session)
          resolve(session)
          dispatch(saveUpdatedShop({ session, shop: session.assignedShop }))
        })
        .catch((err) => console.log(err))
    })
  }
}

export const reviewCompanyAgreement = (email, password) => {
  let formattedEmail = stringFormatter(email)
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(reviewCompanyAgreementAPI(formattedEmail, password), dispatch)
        .then((session) => {
          if (session) {
            dispatch(setDocuSignInfo(session))
          }
          resolve(session)
        })
        .catch((err) => reject(err))
    })
  }
}
export const resetPassword = commonActionAPIHit(
  resetPasswordAPI,
  null,
  'Password reset submitted, Please check your email',
)
export const recoverPassword = commonActionAPIHit(
  recoverPasswordAPI,
  null,
  'Password updated successfully',
)

export const showSessionTimeoutModal = (payload) => {
  return {
    type: SESSION_TIMEOUT_MODAL,
    payload,
  }
}

export const dispatchAuthSuccess = (dispatch, session) => {
  dispatch(authSuccess({ session }))
  clearHubSpot()
  initHubSpot(dispatch, session.employee)
}



// WEBPACK FOOTER //
// ./src/actions/auth.js